interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "GHS";
};

const GHS: Currency = Object.freeze({
  "displayName": "Ghana Cedi",
  "numericCode": 936,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "GHS",
  "symbol": "₵"
});

export { GHS };
